'use client'
import React from 'react'
import { RadioGroup } from '@paladise/ui/components/ui/radio-group'
import { type currentPlanType } from '../type'

export interface IPlan {
  key: currentPlanType
  content: JSX.Element
}
interface Prop {
  plans: IPlan[]
  value: string
  onValueChange: (value: currentPlanType) => void
}

function PlanRadioGroup({ plans, value, onValueChange }: Prop) {
  return (
    <div className="w-full">
      <RadioGroup
        className="flex flex-wrap gap-3"
        value={value}
        onValueChange={onValueChange}
      >
        {plans.map(plan => (
          <div
            className="min1080:w-[260px] flex w-full cursor-pointer flex-col items-end"
            key={plan.key}
            onClick={() => {
              onValueChange(plan.key)
            }}
          >
            {plan.content}
          </div>
        ))}
      </RadioGroup>
    </div>
  )
}

export default PlanRadioGroup
